import React, { FunctionComponent, useEffect } from 'react';
import CallsGraphView from './calls-graph-view';
import { Serie } from '@nivo/line';
import { Loader } from 'semantic-ui-react';

type CallsGraphContainerProps = {
  fetchData: () => Promise<Serie[]>;
};

const CallsGraphContainer: FunctionComponent<CallsGraphContainerProps> = ({
  fetchData,
}) => {
  const [chartData, setChartData] = React.useState<Serie[] | null>(null);

  useEffect(() => {
    setChartData(null);
    fetchData().then((data) => {
      setChartData(data);
    });
  }, [fetchData]);

  if (!chartData) {
    return (
      <div style={{ height: 276 }}>
        <Loader
          size="large"
          active
          inline="centered"
          style={{ marginTop: 224 }}
        />
      </div>
    );
  }

  return <CallsGraphView data={chartData} />;
};

export default CallsGraphContainer;
